// iosKeinEingabeZoom.ts — iPhone/iPad zoomen nicht mehr heran, sobald ein
// Eingabefeld den Fokus bekommt (User 03.11.2026: „kein zoom in“).
//
// Safari auf iOS vergrößert die Seite bei jedem Feld mit Schrift unter 16px und
// lässt sie danach vergrößert stehen. `maximum-scale=1` im Viewport schaltet
// genau dieses automatische Heranzoomen ab; das Aufziehen mit zwei Fingern
// bleibt auf iOS (seit iOS 10) trotzdem möglich. Android zoomt beim Fokus
// nicht — dort würde `maximum-scale=1` aber das Aufziehen sperren, deshalb nur
// auf iOS.

/** iPhone, iPod und iPad — iPadOS meldet sich als „MacIntel“ mit Touch. */
export function istIos(nav: { userAgent: string; platform?: string; maxTouchPoints?: number }): boolean {
  if (/iPhone|iPad|iPod/.test(nav.userAgent)) return true;
  return nav.platform === "MacIntel" && (nav.maxTouchPoints ?? 0) > 1;
}

/** Viewport-Inhalt mit `maximum-scale=1`; ein vorhandener Wert wird ersetzt. */
export function ohneEingabeZoom(content: string): string {
  const teile = content
    .split(",")
    .map((t) => t.trim())
    .filter((t) => t && !/^maximum-scale\s*=/i.test(t));
  return [...teile, "maximum-scale=1"].join(", ");
}

export function installiereIosKeinEingabeZoom(doc: Document = document, nav: Navigator = navigator): void {
  if (!istIos(nav)) return;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return;
  meta.setAttribute("content", ohneEingabeZoom(meta.getAttribute("content") ?? ""));
}
